import {
  APP_SETTING_ADD_PROJECT_CUSTOM_CSS_BEGIN,
  APP_SETTING_ADD_PROJECT_CUSTOM_CSS_SUCCESS,
  APP_SETTING_ADD_PROJECT_CUSTOM_CSS_FAILURE,
  APP_SETTING_ADD_PROJECT_CUSTOM_CSS_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function addProjectCustomCss(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_ADD_PROJECT_CUSTOM_CSS_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/contentCSS`,
        args.data,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: APP_SETTING_ADD_PROJECT_CUSTOM_CSS_SUCCESS,
              data: res.data,
            });
            toast.success('Created Successfully !', {});
            resolve(res.data);
          } else {
            dispatch({
              type: APP_SETTING_ADD_PROJECT_CUSTOM_CSS_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: APP_SETTING_ADD_PROJECT_CUSTOM_CSS_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissAddProjectCustomCssError() {
  return {
    type: APP_SETTING_ADD_PROJECT_CUSTOM_CSS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_ADD_PROJECT_CUSTOM_CSS_BEGIN:
      return {
        ...state,
        addProjectCustomCssPending: true,
        addProjectCustomCssError: null,
      };

    case APP_SETTING_ADD_PROJECT_CUSTOM_CSS_SUCCESS:
      return {
        ...state,
        addProjectCustomCssPending: false,
        addProjectCustomCssError: null,
        projectDetail: action.data,
      };

    case APP_SETTING_ADD_PROJECT_CUSTOM_CSS_FAILURE:
      return {
        ...state,
        addProjectCustomCssPending: false,
        addProjectCustomCssError: action.data.error,
      };

    case APP_SETTING_ADD_PROJECT_CUSTOM_CSS_DISMISS_ERROR:
      return {
        ...state,
        addProjectCustomCssError: null,
      };

    default:
      return state;
  }
}
